import type React from 'react'
import { Coin } from './Coin'
import { useAuth } from '../context/AuthContext'
import { creditsState, creditsTone } from '../utils/creditsState'

/**
 * Иконка токена, ЖИВУЩАЯ состоянием средств юзера (решение владельца
 * 2026-08-07: «единый подход — палитра от условия средств»).
 *
 * Сама берёт баланс из AuthContext и красится через creditsState →
 * creditsTone: brand — всё в порядке, warn (< 100) — пора пополнить,
 * danger (< 30 или 0) — на генерацию не хватает. Пороги общие на весь
 * проект (utils/creditsState), менять их здесь нельзя.
 *
 * ГРАНИЦА ПРИМЕНЕНИЯ: только там, где иконка обозначает БАЛАНС юзера или
 * призыв пополнить (шапка, сайдбар-кнопка токенов, блок баланса в ЛК,
 * анимация пополнения). Ценники моделей, стоимость генерации и объёмы
 * тарифов — это ЦЕНЫ, не средства: там обычный <Coin /> брендовым тоном,
 * красить цену «тревожным» цветом семантически неверно.
 */
type Props = Omit<React.ComponentProps<typeof Coin>, 'tone'>

export const BalanceCoin: React.FC<Props> = (props) => {
	const { user } = useAuth()
	const tone = creditsTone(creditsState(user?.credits_balance ?? 0).level)
	return <Coin tone={tone} {...props} />
}
